import AdminPageVersionsService from "components/adminServices/AdminPageVersionsService";
import generateCRUD from "components/adminServices/generateCRUD";
import SiteService from "services/SiteService";
import { adminProperties, generateContentId, replacePagesByIds } from "utils/adminContentsUtils";
import { removeProperties } from "utils/commonUtils";
import elementsTypes from "utils/elementsTypes";
import enhanceContents from "utils/enhanceContentsUtil";

const SitesCRUD = generateCRUD("sites");

const childCacheKey = "updated";

const prepareContents = (contents) => {
  const cleanContents = contents.map((c) => removeProperties(c, adminProperties));
  return cleanContents.map(replacePagesByIds);
};

export default class AdminSitesService extends SitesCRUD {
  static resetSiteCache = (site) => {
    const { id, contents } = site;
    const cacheChild = contents.find((c) => c.key === childCacheKey);
    let newContents = [];
    if (cacheChild) {
      newContents = contents.map((c) => (c.id === cacheChild.id ? { ...cacheChild, value: `${new Date()}` } : c));
    } else {
      newContents = [
        ...contents,
        generateContentId({
          type: elementsTypes.INPUT,
          key: childCacheKey,
          value: `${new Date()}`,
        }),
      ];
    }

    SitesCRUD.update({ id, contents: prepareContents(newContents) });
  };

  static update = async (site) => {
    const { contents } = site;
    const siteUpdated = await SitesCRUD.update({
      ...site,
      contents: prepareContents(contents),
    });

    // refresh front office sites
    await SiteService.get(site.name);

    return siteUpdated;
  };

  static get = async (id, isBo = false) => {
    const site = await SitesCRUD.get(id);
    if (site && isBo) {
      enhanceContents({ contents: site.contents, getPages: AdminPageVersionsService.getPageVersions }).then(
        (responses) => {
          site.contents = responses;
        },
      );
    }
    return site;
  };
}
